<script setup lang="ts">
import { Drawer, DrawerContent, DrawerTitle } from "~/components/ui/drawer";

const props = withDefaults(
  defineProps<{
    /** Accessible title, visually hidden (drawers here use their own in-body heading). */
    title: string;
    /** Element the sheet portals into — keeps it confined to the app-frame container instead of the full viewport. */
    teleportTo?: string;
    /** Size the sheet to its content (capped) instead of the tall fixed height. */
    fitContent?: boolean;
  }>(),
  {
    teleportTo: "#layout-drawer-root",
    fitContent: false,
  },
);

const open = defineModel<boolean>("open", { default: false });

const heightClass = computed(() =>
  props.fitContent
    ? "h-auto data-[vaul-drawer-direction=bottom]:max-h-[calc(100%-88px)]"
    : "h-[calc(100%-88px)] data-[vaul-drawer-direction=bottom]:max-h-none",
);
</script>

<template>
  <Drawer v-model:open="open">
    <DrawerContent
      :to="teleportTo"
      :class="[
        'pointer-events-auto inset-x-0 bottom-0 mx-auto w-full max-w-[600px] shadow-2xl data-[vaul-drawer-direction=bottom]:mt-0 data-[vaul-drawer-direction=bottom]:rounded-t-3xl',
        heightClass,
      ]"
    >
      <DrawerTitle class="sr-only">{{ title }}</DrawerTitle>
      <div class="min-h-0 flex-1 overflow-y-auto scrollbar-hide pt-2">
        <slot />
      </div>
      <div v-if="$slots.footer" class="shrink-0">
        <slot name="footer" />
      </div>
    </DrawerContent>
  </Drawer>
</template>
